import { mount } from '../dom-lifecycle';

mount('script[data-flash-messages]', function () {
    const flashes = JSON.parse(this.textContent);
    for (const type in flashes) {
        for (const message of flashes[type]) {
            alert(message, type === 'error' ? 'danger' : type);
        }
    }
});
